export default {
  pageId: '2002201', 
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    favorite: {
      buttonId: '200220101',
    },
    addFavorite: {
      buttonId: '200220102',
    }
  },
};
